import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../constants/common'
import {
  DOC_FLOW_REQUEST_LINKS_MAX_COUNT,
  DocFlowTableCellName,
} from '../../constants/docFlow'
import { getPaginationApiParams } from '../../utils/pagination'
import { toOrderingList } from '../../utils/sort'

import { DOC_FLOW_SELECT_MODAL_NOTIFICATION_ID } from './DocFlowSelectModal.constants'

export function isDocFlowSelectModalSelectionEmpty({ selected }) {
  return selected.length === 0
}

export function getDocFlowSelectModalRequestParams({
  ordering,
  page,
  pageSize,
  search,
}) {
  return {
    ...(search ? { search } : null),
    ...getPaginationApiParams({ page, pageSize }),
    ordering: toOrderingList(ordering),
  }
}

export function getDocFlowSelectModalTableColumns() {
  return {
    [DocFlowTableCellName.DocumentsCount]: {
      index: 1,
      name: DocFlowTableCellName.DocumentsCount,
      ordering_field: 'documents_count',
      title: 'Modal.DocFlowSelectColumnDocumentsKey',
      visible: true,
      width: 150,
    },
    [DocFlowTableCellName.EpostSpentCredits]: {
      index: 3,
      name: DocFlowTableCellName.EpostSpentCredits,
      ordering_field: 'epost_spent_credits',
      title: 'Modal.DocFlowSelectColumnSpendCreditsKey',
      visible: true,
      width: 200,
    },
    [DocFlowTableCellName.Name]: {
      index: 0,
      name: DocFlowTableCellName.Name,
      ordering_field: 'name',
      title: 'Modal.DocFlowSelectColumnTitleKey',
      visible: true,
      width: 496,
    },
    [DocFlowTableCellName.Phase]: {
      index: 4,
      name: DocFlowTableCellName.Phase,
      ordering_field: 'phase',
      title: 'Modal.DocFlowSelectColumnPhaseKey',
      visible: true,
      width: 200,
    },
    [DocFlowTableCellName.Status]: {
      index: 2,
      name: DocFlowTableCellName.Status,
      ordering_field: 'status',
      title: 'Modal.DocFlowSelectColumnStatusKey',
      visible: true,
      width: 176,
    },
  }
}

export function getDocFlowSelectModalItemsFromResponse(data) {
  return { items: data.items }
}

export function getDocFlowSelectModalInitialNotifications({
  showLimitNotification,
  t,
}) {
  return showLimitNotification
    ? [
        {
          id: DOC_FLOW_SELECT_MODAL_NOTIFICATION_ID.limitInfo,
          text: t('Modal.ConnectDocFlowsLimitNotificationKey', {
            limit: DOC_FLOW_REQUEST_LINKS_MAX_COUNT,
          }),
          type: NOTIFICATION_TYPE.info,
        },
      ]
    : EMPTY_LIST
}
